import _defineProperty from "@babel/runtime/helpers/defineProperty";
import { getDeliveryOptions } from '../utils';
import { deliverySolutionsErrorsMapper } from '../utils/deliverySolutionsErrorsMapper';
import { deliveryOptionsMapper, sortDeliveryOptionsByPrice, splitDeliveryOptionsToPickupAndDelivery } from '../utils/deliveryOptionsMappers';
import { loadI18n } from '../utils/i18n';
import { SPECS } from '../specs';
export class DeliveryOptionsService {
  constructor(params) {
    _defineProperty(this, "httpClient", void 0);
    _defineProperty(this, "errorHandler", void 0);
    _defineProperty(this, "timezone", void 0);
    _defineProperty(this, "locale", void 0);
    _defineProperty(this, "translationLang", void 0);
    _defineProperty(this, "experiments", void 0);
    _defineProperty(this, "t", void 0);
    const {
      locale,
      translationLang,
      timezone,
      httpClient,
      errorHandler,
      experiments
    } = params;
    this.locale = locale;
    this.translationLang = translationLang;
    this.timezone = timezone;
    this.httpClient = httpClient;
    this.errorHandler = errorHandler;
    this.experiments = experiments;
  }
  async init(t) {
    this.t = t ? t : (await loadI18n(this.translationLang)).t;
  }
  async fetchDeliveryOptions(deliverySectionParams) {
    try {
      const shouldUseDeliverySolutions = this.experiments.enabled(SPECS.DeliverySectionCheckoutUseDeliverySolutions);
      const result = shouldUseDeliverySolutions ? await getDeliveryOptions(this.httpClient, this.errorHandler.withErrorHandler, {
        currency: deliverySectionParams == null ? void 0 : deliverySectionParams.currency,
        destination: deliverySectionParams == null ? void 0 : deliverySectionParams.destination,
        lineItems: deliverySectionParams == null ? void 0 : deliverySectionParams.lineItems,
        contactDetails: deliverySectionParams == null ? void 0 : deliverySectionParams.contactDetails,
        userPreferences: deliverySectionParams == null ? void 0 : deliverySectionParams.userPreferences,
        purchaseFlowId: deliverySectionParams == null ? void 0 : deliverySectionParams.purchaseFlowId,
        weightUnit: deliverySectionParams == null ? void 0 : deliverySectionParams.weightUnit
      }) : deliverySectionParams.fallbackDeliveryOptions;
      const deliverySolutions = result.deliverySolutions;
      const errors = deliverySolutionsErrorsMapper(result.errors);
      return {
        deliverySolutions,
        errors
      };
    } catch (error) {
      this.errorHandler.getResolvedError(error);
      return {
        deliverySolutions: []
      };
    }
  }
  async getDeliveryOptions(deliverySectionParams, selectedDeliveryCode, shouldShowOnlyPickup) {
    const shouldSortOptions = !this.experiments.enabled(SPECS.SupportDeliveryProfilesPhase2);
    const {
      deliverySolutions,
      errors
    } = await this.fetchDeliveryOptions(deliverySectionParams);
    const {
      selectedDeliveryOption,
      groupedDeliveryOptions,
      hasPartialShippingOptions
    } = deliveryOptionsMapper(deliverySolutions, {
      timezone: this.timezone,
      selectedDeliveryCode,
      shouldShowOnlyPickup,
      t: this.t,
      language: this.locale
    });
    const groupedDeliveryOptionsValues = Object.values(groupedDeliveryOptions);
    const deliveryOptionsList = shouldSortOptions ? sortDeliveryOptionsByPrice(groupedDeliveryOptionsValues) : groupedDeliveryOptionsValues;
    const deliveries = splitDeliveryOptionsToPickupAndDelivery(deliveryOptionsList);
    const canShipToDestination = !!deliveryOptionsList.length;
    return {
      errors,
      deliveries,
      canShipToDestination,
      selectedDeliveryOption,
      hasPartialShippingOptions
    };
  }
}
//# sourceMappingURL=DeliveryOptionsService.js.map